import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import UserInputStore from "@ipru-common/store/UserInputStore";
import {
  convertToISODate,
  getCurrentProductFromMeta,
  isWegaPersona,
  readQueryParams,
} from "@ipru-common/utils/CommonFunctions";
import { CreateCookie, netCoreEvent } from "../CreateCookie";
import getIPSUserInput from "./IpsUserInput";
import getSmartKidUserInput from "./SmartKIdUserInput";
import getSignatureUlipUserInput from "./SignatureUlipUserInput";
import getGiftProUserInput from "./GiftProUserInput";
import getIPSNetCoreInput from "./IpsNetCoreInput";
import getSignatureUlipNetCoreInput from "./SignatureNetCoreInput";
import getPngNetCoreInput from "./PngNetCoreInput";
import getGiftProNetCoreInput from "./GiftProNetCoreInput";
import getSignatureAssureNetCoreInput from "./SignatureAssureNetCoreInput";
import getGppFlexiUserInput from "./GppFlexiUserInput";
import getGppFlexiNetCoreInput from "./GppFlexiNetCoreInput";
import getSaralPensionUserInput from "./SaralPensionUserInput";
import getSaralPensionNetCoreInput from "./SaralPensionNetCoreInput";
import getSIPPlusUserInput from "./SIPPlusUserInput";
import getSignatureSIPPlusNetCoreInput from "./SignatureSIPPlusNetCoreInput";
import getIwishNetCoreInput from "./IwishNetCoreInput";
import getSmartKidAssureUserInput from "./SmartKidAssureUserInput";
import getSmartKidAssureNetcoreInput from "./SmartKidAssureNetcoreInput";
import getIPSSuperNetCoreInput from "./IpsSuperNetCoreInput";
import { PRODUCT_KEYS } from "@ipru-common/constants/products";
import getICARENetCoreInput from "./IcareNetcoreInput";
import getcg2UserInput from "./cg2UlipUserInput";
import getcg2NetCoreInput from "./cg2NetCoreInput";
import getGiftCityNetCoreInput from "@ipru-common/utils/UserInputMapper/GiftCityNetCoreInput";
import getGiftCityUserInput from "./GiftCityUlipUserInput";
import { CurrentProduct } from "shared-library";
import getSignatureSecureUlipInput from "./SignatureSecureUlipInput";
import getWealthAcceleratorUlipUserInput from "./WealthAcceleratorUlipUserInput";
import getWealthAcceleratorNetCoreInput from "./WealthAcceleratorNetCoreInput";
import getSignatureSecureNetCoreInput from "./SignatureSecureNetCoreInput";
import getSmartKid360NetcoreInput from "./SmartKid360NetcoreInput";
import getSmartKid360UserInput from "./SmartKid360UserInput";

const CommonKeys = (calculatorFormData, existingCustomer, quoteFormData) => {
  const queryParams = readQueryParams();

  return {
    age: calculatorFormData?.age,
    dob: convertToISODate(calculatorFormData.user_dob),
    gender: calculatorFormData?.gender,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    term: quoteFormData?.term,
    MobileNo: calculatorFormData?.mobileno,
    EmailId: calculatorFormData?.emailid,
    AnnualIncome: calculatorFormData?.yr_income,
    Occupation: calculatorFormData?.calc_occupation,
    City: calculatorFormData?.city,
    pincode: calculatorFormData?.pincode,
    qdata: queryParams?.get("qdata"),
    trai_flag: calculatorFormData?.trai_flag,
    existingCustomer: existingCustomer?.clientId ? "Yes" : "No",
  };
};

const userInputMapper = {
  [PRODUCT_KEYS.IPS]: getIPSUserInput,
  [PRODUCT_KEYS.SMARTKID]: getSmartKidUserInput,
  [PRODUCT_KEYS.SIGNATUREULIP]: getSignatureUlipUserInput,
  [PRODUCT_KEYS.GIFTPRO]: getGiftProUserInput,
  [PRODUCT_KEYS.PNG]: getGiftProUserInput,
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: getSignatureUlipUserInput,
  [PRODUCT_KEYS.GPP_FLEXI]: getGppFlexiUserInput,
  [PRODUCT_KEYS.SARAL_PENSION]: getSaralPensionUserInput,
  [PRODUCT_KEYS.SIP_PLUS]: getSIPPlusUserInput,
  [PRODUCT_KEYS.SMARTKID_ASSURE]: getSmartKidAssureUserInput,
  [PRODUCT_KEYS.OTC_SJB]: getIPSUserInput,
  [PRODUCT_KEYS.ICARE]: getIPSUserInput,
  [PRODUCT_KEYS.CAPITAL_GUARANTEE_II]: getcg2UserInput,
  [PRODUCT_KEYS.GIFT_CITY]: getGiftCityUserInput,
  [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: getWealthAcceleratorUlipUserInput,
  [PRODUCT_KEYS.SIGNATURE_SECURE]: getSignatureSecureUlipInput,
  [PRODUCT_KEYS.SMARTKID_360]: getSmartKid360UserInput,
};

const netCoreInputMapper = {
  [PRODUCT_KEYS.IPS]: getIPSNetCoreInput,
  [PRODUCT_KEYS.SIGNATUREULIP]: getSignatureUlipNetCoreInput,
  [PRODUCT_KEYS.SIGNATURE_ASSURE]: getSignatureAssureNetCoreInput,
  [PRODUCT_KEYS.PNG]: getPngNetCoreInput,
  [PRODUCT_KEYS.GIFTPRO]: getGiftProNetCoreInput,
  [PRODUCT_KEYS.GPP_FLEXI]: getGppFlexiNetCoreInput,
  [PRODUCT_KEYS.SARAL_PENSION]: getSaralPensionNetCoreInput,
  [PRODUCT_KEYS.SIP_PLUS]: getSignatureSIPPlusNetCoreInput,
  [PRODUCT_KEYS.IWISH]: getIwishNetCoreInput,
  [PRODUCT_KEYS.SMARTKID_ASSURE]: getSmartKidAssureNetcoreInput,
  [PRODUCT_KEYS.OTC_SJB]: getIPSUserInput,
  [PRODUCT_KEYS.IPS_SUPER]: getIPSSuperNetCoreInput,
  [PRODUCT_KEYS.ICARE]: getICARENetCoreInput,
  [PRODUCT_KEYS.CAPITAL_GUARANTEE_II]: getcg2NetCoreInput,
  [PRODUCT_KEYS.GIFT_CITY]: getGiftCityNetCoreInput,
  [PRODUCT_KEYS.GLOBAL_WEALTH_ACCELERATOR]: getWealthAcceleratorNetCoreInput,
  [PRODUCT_KEYS.SIGNATURE_SECURE]: getSignatureSecureNetCoreInput,
  [PRODUCT_KEYS.SMARTKID_360]: getSmartKid360NetcoreInput,
};

export const updateUserInput = async (callFeedbackApi) => {
  const userDataInput = userInputMapper?.[getCurrentProductFromMeta()]?.();
  const netCoreDataInput = CurrentProduct?.netcoreMapper?.() ?? netCoreInputMapper?.[getCurrentProductFromMeta()]?.();
  UserInputStore.setUserInput();

  CreateCookie(userDataInput);
  if (!isWegaPersona()) {
    netCoreEvent(netCoreDataInput, callFeedbackApi);
  }
};

export default CommonKeys;
